export const NOTTYPED = 0;
export const MISS = 1;
export const HIT = 2;
export const OVERFLOW = 3;
